// extracted by mini-css-extract-plugin
export default {"btn":"WhatsAppButton_btn__yFtX2","icon":"WhatsAppButton_icon__8RMOn","label":"WhatsAppButton_label__eA1Oz","waPulse":"WhatsAppButton_waPulse__188hq"};